import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Button,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import newsData from '../data/NewsData.json'; 

const Home = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  return (
    <div>
     

      {/* Intro Paragraph */}
      <Box component="main" sx={{ p: 4, textAlign: 'center' }}>
        <Typography
          variant="body1"
          sx={{
            maxWidth: '800px',
            mx: 'auto',
            textAlign: 'justify',
            fontSize: { xs: '1rem', sm: '1.25rem' },
            lineHeight: 1.6,
          }}
        >
          {t('home.description')}
        </Typography>
      </Box>

      {/* Transportation Master Plan Update Section */}
<Box
  sx={{
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    width: '100%',
    height: { xs: 'auto', md: '400px' },
    overflowX: 'hidden',
  }}
>
  {/* Left Column (Image) */}
<Box
  sx={{
    width: { xs: '100%', md: '50%' },
    height: { xs: '300px', md: 'auto' },
    boxSizing: 'border-box',
    position: 'relative',
    overflow: 'hidden',
  }}
>
  {/* Image */}
  <Box
    component="img"
    src={`${process.env.PUBLIC_URL}/images/transportation_plan.jpg`}
    alt={t('home.transportation_plan_alt', 'Transportation Master Plan Image')}
    sx={{
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
      zIndex: 0, position: 'relative',
    }}
  />

  {/* Dark Overlay */}
  <Box
    sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.4)', // Adjust opacity as needed
    }}
  />
</Box>


  {/* Right Column (Text) */}
  <Box
    sx={{
      width: { xs: '100%', md: '50%' },
      bgcolor: '#33834a',
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxSizing: 'border-box',
    }}
  >
    <Box
      sx={{
        width: '100%',
        px: { xs: 2, sm: 4 },
        py: 4,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 2,
        boxSizing: 'border-box',
        maxWidth: '100%',
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontSize: { xs: '2rem', md: '2.5rem' },
          mt: -2,
          mb: 4,
        }}
      >
        {t('home.transortation_master_plan_title', 'Get Involved')}
      </Typography>

      <Typography variant="body1" sx={{ fontSize: { xs: '1.1rem', md: '1.25rem' } }}>
        {t(
          'home.transortation_master_plan_text',
          'Vision Zero involves collaboration among various stakeholders, including government agencies, transportation departments, law enforcement, community organizations, and the public. Each plays a role in implementing strategies to improve road safety. There are many ways to get involved, from our Taskforce, to public workshops, and more!'
        )}
      </Typography>

      <Box sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-end' } }}>
        <Button
          variant="contained"
                    onClick={() => {
  navigate('/miami-lakes-transportation-master-plan');
   window.scrollTo({ top: 0, behavior: 'smooth' });
}}
          sx={{
            backgroundColor: 'black',
            color: 'white',
            '&:hover': { backgroundColor: '#333' },
          }}
        >
          {t('home.get_transortation_master_plan_button', 'Learn More')}
        </Button>
      </Box>
    </Box>
  </Box>
</Box>


    {/*Greenways and Trails Master Plan Section */}
<Box
  sx={{
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    width: '100%',
    height: { xs: 'auto', md: '400px' },
    overflowX: 'hidden',
  }}
>
  {/* Left Column (Text) */}
  <Box
    sx={{
      width: { xs: '100%', md: '50%' },
      boxSizing: 'border-box',
      bgcolor: '#fff',
      color: 'black',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Box
      sx={{
        width: '100%',
        px: { xs: 2, sm: 4 },
        py: 4,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 2,
        boxSizing: 'border-box',
        maxWidth: '100%',
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontSize: { xs: '2rem', md: '2.5rem' },
          mt: -2,
          mb: 4,
        }}
      >
        {t('home.greenways_plan_title', 'PUBLIC INPUT')}
      </Typography>

      <Typography variant="body1" sx={{ fontSize: { xs: '1.1rem', md: '1.25rem' } }}>
        {t('home.greenways_plan_text')}
      </Typography>

      <Box sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-end' } }}>
        <Button
          variant="contained"
                              onClick={() => {
  navigate('/miami-lakes-greenways-trails-master-plan');
   window.scrollTo({ top: 0, behavior: 'smooth' });
}}
          sx={{
            backgroundColor: 'black',
            color: 'white',
            '&:hover': { backgroundColor: '#333' },
          }}
        >
          {t('home.greenways_plan_button', 'Learn More')}
        </Button>
      </Box>
    </Box>
  </Box>

  {/* Right Column (Image) */}
<Box
  sx={{
    width: { xs: '100%', md: '50%' },
    height: { xs: '300px', md: 'auto' },
    boxSizing: 'border-box',
    position: 'relative', // add this
  }}
>
    <Box
      component="img"
      src={`${process.env.PUBLIC_URL}/images/greenways_plan.jpg`}
      alt={t('home.greenways_plan_image_alt', 'Greenways')}
      sx={{
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        display: 'block',
        zIndex: 0, position: 'relative',
      }}
    />
 
    <Box
    sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.4)', // Adjust opacity as needed
    }}
  />
</Box>
</Box>

      {/*Complete Streets Master Plan  Section */}
<Box
  sx={{
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    width: '100%',
    height: { xs: 'auto', md: '400px' },
    overflowX: 'hidden',
  }}
>
  {/* Left Column (Image) */}
<Box
  sx={{
    width: { xs: '100%', md: '50%' },
    height: { xs: '300px', md: 'auto' },
    boxSizing: 'border-box',
    position: 'relative',
    overflow: 'hidden',
  }}
>
  {/* Image */}
  <Box
    component="img"
    src={`${process.env.PUBLIC_URL}/images/streets_plan.jpg`}
    alt={t('home.streets_plan_image_alt', 'Streets Plan')}
    sx={{
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
      zIndex: 0, position: 'relative',
    }}
  />

  {/* Dark Overlay */}
  <Box
    sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.4)', // Adjust opacity as needed
    }}
  />
</Box>


  {/* Right Column (Text) */}
  <Box
    sx={{
      width: { xs: '100%', md: '50%' },
      bgcolor: '#ffb606',
      color: 'black',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxSizing: 'border-box',
    }}
  >
    <Box
      sx={{
        width: '100%',
        px: { xs: 2, sm: 4 },
        py: 4,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 2,
        boxSizing: 'border-box',
        maxWidth: '100%',
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontSize: { xs: '2rem', md: '2.5rem' },
          mt: -2,
          mb: 4,
        }}
      >
        {t('home.complete_streets_plan_title', 'Complete Streets Master Plan')}
      </Typography>

      <Typography variant="body1" sx={{ fontSize: { xs: '1.1rem', md: '1.25rem' } }}>
        {t(
          'home.complete_streets_plan_text'        )}
      </Typography>

      <Box sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-end' } }}>
        <Button
          variant="contained"
          onClick={() => {
  navigate('/miami-lakes-complete-streets-master-plan');
   window.scrollTo({ top: 0, behavior: 'smooth' });
}}

          sx={{
            backgroundColor: 'black',
            color: 'white',
            '&:hover': { backgroundColor: '#333' },
          }}
        >
          {t('home.complete_streets_plan_button', 'Learn More')}
        </Button>
      </Box>
    </Box>
  </Box>
</Box>


    {/*Comprehensive Vision Zero Safety Action Plan    */}
<Box
  sx={{
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    width: '100%',
    height: { xs: 'auto', md: '400px' },
    overflowX: 'hidden',
  }}
>
  {/* Left Column (Text) */}
  <Box
    sx={{
      width: { xs: '100%', md: '50%' },
      boxSizing: 'border-box',
      bgcolor: '#fff',
      color: 'black',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Box
      sx={{
        width: '100%',
        px: { xs: 2, sm: 4 },
        py: 4,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 2,
        boxSizing: 'border-box',
        maxWidth: '100%',
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontSize: { xs: '2rem', md: '2.5rem' },
          mt: -2,
          mb: 4,
        }}
      >
        {t('home.comprehensive_plan_title', 'Comprehensive Vision Zero Safety Action Plan')}
      </Typography>

      <Typography variant="body1" sx={{ fontSize: { xs: '1.1rem', md: '1.25rem' } }}>
        {t('home.comprehensive_plan_text')}
      </Typography>

      <Box sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-end' } }}>
        <Button
          variant="contained"
          onClick={() => {
  navigate('/miami-lakes-about');
   window.scrollTo({ top: 0, behavior: 'smooth' });
}}
          sx={{
            backgroundColor: 'black',
            color: 'white',
            '&:hover': { backgroundColor: '#333' },
          }}
        >
          {t('home.comprehensive_plan_button', 'Learn More')}
        </Button>
      </Box>
    </Box>
  </Box>

  {/* Right Column (Image) */}
<Box
  sx={{
    width: { xs: '100%', md: '50%' },
    height: { xs: '300px', md: 'auto' },
    boxSizing: 'border-box',
    position: 'relative', // add this
  }}
>
    <Box
      component="img"
      src={`${process.env.PUBLIC_URL}/images/comprehensive_plan.jpg`}
      alt={t('home.comprehensive_plan_image_alt', 'Comprehensive Plan')}
      sx={{
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        display: 'block',
        zIndex: 0, position: 'relative',
      }}
    />
 
    <Box
    sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.4)', // Adjust opacity as needed
    }}
  />
</Box>
</Box>
{/* Resources Section */}
{/* 
<Box
  sx={{
    position: 'relative',
    width: '100%',
    height: { xs: 'auto', md: '50vh' },
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    
    py: { xs: 2, md: 0 },
    flexDirection: 'column',
    maxWidth: '100vw'
  }}
>


  <Box
    component="img"
    src="/images/resources-bg.jpg"
    alt="Resources background"
    sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      zIndex: 0,
    }}
  />


  <Box
    sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 1,
    }}
  />


<Box
  sx={{
    position: 'relative',
    zIndex: 2,
    color: 'white',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 3,
    maxWidth: '100%', // constrain content to page width
    width: '100%',
    px: 2,
    boxSizing: 'border-box', // ensure padding doesn't overflow
  }}
>

    <Typography variant="h3" sx={{ fontSize: { xs: '2rem', md: '2.5rem' } }}>
      {t('home.resources_title', 'Vision Zero Resources')}
    </Typography>
<Typography
  variant="body1"
  sx={{
    fontSize: { xs: '1rem', md: '1.25rem' },
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    maxWidth: '100%',
    px: { xs: 2, sm: 4, md: 8 }, // add horizontal padding for safety
    textAlign: 'center', // ensure text is visually centered
  }}
>
  {t(
    'home.resources_text',
    'Are you committed to the belief that every life matters on our roadways? Visit our Vision Zero resource page to learn more about this traffic safety philosophy aiming to prevent all serious injuries and fatalities. Join cities around the world striving for the vision of zero deaths by starting your journey on our Vision Zero resource page.'
  )}
</Typography>

    <Button
      variant="contained"
      sx={{
        backgroundColor: '#FDB51F',
        color: 'black',
        fontWeight: 'bold',
        '&:hover': { backgroundColor: '#e0a519' },
      }}
    >
      {t('home.resources_button', 'Resources')}
    </Button>
  </Box>
</Box> 
*/}

{/* Timeline Section */}
<Box
  sx={{
    width: '100%',
    bgcolor: '#f5f5f5', // optional light background
    py: { xs: 6, md: 8 },
    px: { xs: 2, sm: 4 },
    textAlign: 'center',
    overflowX: 'hidden',
    boxSizing: 'border-box', 
  }}
>
  <Typography
    variant="h3"
    sx={{
      fontSize: { xs: '2rem', md: '2.5rem' },
      mb: 4,
      color: 'black',
    }}
  >
    {t('home.timeline_title', 'Timeline')}
  </Typography>

  <Box
    component="img"
    src={`${process.env.PUBLIC_URL}/images/home-timeline.jpg`}
    alt={t('home.timeline_image_alt', 'Timeline Image')}
    sx={{
      width: '100%',
      maxWidth: '1200px',
      height: 'auto',
      objectFit: 'contain',
      borderRadius: 2,
      mx: 'auto',
      boxShadow: 2,
    }}
  />
</Box>


{/* News Section */}
<Box
  sx={{
    position: 'relative',
    width: '100%',
    bgcolor: 'black',
    color: 'white',
    textAlign: 'center',
    py: { xs: 4, md: 8 },
    px: { xs: 0, sm: 0 },
    maxWidth: '100vw',
  }}
>
  {/* Section Title */}
  <Typography variant="h3" sx={{ fontSize: { xs: '2rem', md: '2.5rem' }, mb: 2 }}>
    {t('home.news_title', 'News')}
  </Typography>

  {/* Section Description */}
  <Typography
    variant="body1"
    sx={{
      fontSize: { xs: '1rem', md: '1.25rem' },
      mb: 4,
      maxWidth: '800px',
      mx: 'auto',
    }}
  >
    {t(
      'home.news_description'
    )}
  </Typography>

{/* Cards Container */}
<Box
  sx={{
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    justifyContent: 'center',
    alignItems: 'stretch',
    gap: 4,
    mb: 4,
    px: { xs: 0, sm: 4 },
    mx: 'auto',
    maxWidth: '1200px',
  }}
>
  {newsData.slice(0, 2).map((item) => {
    const localizedText = i18n.language === 'es' ? item.text_es : item.text_en;

    return (
<Box
  key={item.id}
  sx={{
    backgroundColor: 'white',
    borderRadius: 2,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    color: 'black',
    flex: '1 1 auto', // let it grow/shrink within constraints
    width: { xs: '100%', sm: '80%', md: '360px' }, // fixed width at md+, full width on mobile
    mx: 'auto', // center on mobile
  }}
>


        {/* Card Image */}
        <Box
          component="img"
          src={`${process.env.PUBLIC_URL}${item.image}`}
          alt={localizedText}
          sx={{ width: '100%', height: '350px', objectFit: 'cover' }}
        />

        {/* Card Content */}
        <Box sx={{ p: 3, flexGrow: 1 }}>
 <Typography
  variant="body2"
  sx={{
    mb: 3,
    lineHeight: 1.2,
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    minHeight: '3.5em', // ensures space for 2 lines
  }}
>
  {localizedText}
</Typography>

          <Button
            variant="contained"
            onClick={() => window.open(item.link, '_blank')}
            sx={{
              backgroundColor: 'black',
              color: 'white',
              '&:hover': { backgroundColor: '#333' },
            }}
          >
            {t('home.news_card_button', 'Read More')}
          </Button>
        </Box>
      </Box>
    );
  })}
</Box>

  {/* Bottom CTA Button */}
  <Button
    variant="contained"
               onClick={() => {
  navigate('/miami-lakes-news');
   window.scrollTo({ top: 0, behavior: 'smooth' });
}}
    sx={{
      backgroundColor: 'white',
      color: 'black',
      fontWeight: 'bold',
      '&:hover': { backgroundColor: '#e0e0e0' },
    }}
  >
    {t('home.news_button', 'View All News')}
  </Button>
</Box>




{/* FAQ Section */}
<Box
  sx={{
    width: '100%',
    backgroundColor: '#f7f7f7',
    py: { xs: 4, md: 6 },
    px: { xs: 0, sm: 0, md: 0 },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  }}
>
  <Typography
    variant="h3"
    sx={{
      fontSize: { xs: '2rem', md: '2.5rem' },
      mb: 4,
      textAlign: 'center',
    }}
  >
    {t('home.faq_title', 'Frequently Asked Questions')}
  </Typography>

  <Box sx={{ maxWidth: '900px', width: '95%' }}>
    {[1, 2, 3,4,5,6,7,8].map((item) => (
      <Accordion key={item} sx={{ mb: 2 }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          sx={{
            backgroundColor: '#fff',
            borderLeft: '8px solid #ff4002',
            px: 2,
          }}
        >
          <Typography variant="h6" sx={{ fontSize: { xs: '1rem', md: '1.1rem' } }}>
            {t(`home.faq_q${item}`, `Sample Question ${item}?`)}
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ backgroundColor: '#fff', px: 2 }}>
          <Typography variant="body1" sx={{ fontSize: { xs: '0.95rem', md: '1rem' } }}>
            {t(
              `home.faq_a${item}`,
              `This is a sample answer to question ${item}. You can customize this text in your translation file.`
            )}
          </Typography>
        </AccordionDetails>
      </Accordion>
    ))}
  </Box>
</Box>



    </div>
  );
};

export default Home;
